<script setup lang="ts">
import { faIconStyle } from '~/utils/faIconStyle'

const { getFormations } = useHome()
const { data: formations } = await useAsyncData('home-formations', () => getFormations())
</script>

<template>
  <section class="py-section-py bg-background relative overflow-hidden transition-colors duration-300">
    <!-- Background decoration -->
    <div class="absolute top-0 left-0 w-full h-px bg-linear-to-r from-transparent via-oxo-border to-transparent"></div>
    
    <div class="container mx-auto px-container-px relative z-10">
      <UiSectionHeader 
        titlePrefix="NOS"
        titleHighlight="FORMATIONS"
        subtitle="Deux parcours experts pour devenir un professionnel accompli du développement ou de l'art numérique."
        class="mb-section-header-mb"
      />

      <div v-if="formations" class="flex flex-row flex-wrap justify-center items-center gap-8 mb-16">
        <article 
          v-for="(formation, index) in formations" 
          :key="index"
          class="group relative bg-oxo-card-bg p-6 rounded-2xl border border-oxo-border transition-all duration-300 hover:-translate-y-2 hover:shadow-xl dark:hover:shadow-[0_0_30px_rgba(255,255,255,0.05)] flex flex-col overflow-hidden w-[450px] max-w-full flex-none"
          :class="formation.classes.borderHover"
        >
          <!-- Background Image & Overlay -->
          <NuxtLink :to="formation.link" class="absolute inset-0 z-10 focus:outline-hidden" aria-hidden="true" tabindex="-1" :aria-label="'Voir la formation ' + formation.title" />
          <div class="absolute inset-0 z-0">
             <NuxtImg loading="lazy"
                v-if="formation.image"
                :src="formation.image"
                :alt="formation.title"
                class="w-full h-full object-cover opacity-40 group-hover:opacity-60 transition-opacity duration-500 scale-100 group-hover:scale-110 transform"
                sizes="450px"
              />
              <div class="absolute inset-0 bg-card-overlay-gradient z-10 transition-opacity duration-300 group-hover:opacity-90"></div>
              
              <!-- RNCP Badge -->
              <div class="absolute top-4 right-4 z-20 pointer-events-none">
                <UiBadge 
                  v-if="formation.isRncp !== undefined"
                  :variant="formation.isRncp ? 'info' : 'primary'"
                >
                  {{ formation.isRncp ? 'RNCP' : 'Certificat OXO' }}
                </UiBadge>
              </div>
          </div>

          <!-- Icon -->
          <div 
            class="relative z-10 mb-6 inline-flex items-center justify-center w-14 h-14 rounded-xl bg-oxo-card-bg/20 transition-colors duration-300 pointer-events-none"
            :class="formation.classes.iconBgHover"
          >
            <i :style="faIconStyle('fas fa-' + formation.icon.replace('fa-', ''))" :class="['fas', 'fa-' + formation.icon.replace('fa-', ''), 'text-2xl transition-colors duration-300', formation.classes.icon]" aria-hidden="true"></i>
          </div>

          <!-- Content -->
          <h3 
            class="relative z-10 font-display font-bold text-xl text-foreground mb-3 transition-colors duration-300 drop-shadow-lg pointer-events-none"
            :class="formation.classes.titleHover"
          >
            {{ formation.title }}
          </h3>
          <p class="relative z-10 text-foreground mb-6 leading-relaxed text-sm grow drop-shadow-md pointer-events-none">
            {{ formation.description }}
          </p>

          <!-- Link -->
          <AppButton 
            :to="formation.link" 
            variant="outline" 
            size="sm" 
            class="relative z-20 w-full mt-auto group-hover:text-white dark:group-hover:text-white pointer-events-auto"
            :class="formation.classes.buttonHover"
          >
            En savoir plus
          </AppButton>
        </article>
      </div>



    </div>
  </section>
</template>
